
import { Vue, Component } from 'vue-property-decorator';
import TDialog from './dialog.vue';
import TIcon from './icon/index';

@Component({
  components: {
    TDialog,
    TIcon,
  },
})
export default class TMessage extends Vue {
  private show: boolean = true;

  private title: string = '提示';

  private iconImg: string = '';

  private iconType: string = 'info';

  private message: string = '';

  private supperHTMLString: boolean = false;

  private hasCancelButton: boolean = true;

  private cancelButtonText: string = '取消';

  private confirmButtonText: string = '确定';

  private controlButtonCenter: boolean = false;

  private loading: boolean = false;

  private confrimLoading: boolean = false;

  private cancelButtonClassName: string = 't-message-button--cancel';

  private confirmButtonClassName: string = 't-message-button--confirm';

  private closeType: string = 'dialog';

  private handleClickModal: boolean = true;

  private handleEscModal: boolean = true;

  private callback?: Function;

  public $refs!: {
    dialog: TDialog,
  }

  get hasIcon() {
    return TIcon.hasIcon(this.iconType);
  }

  private close() {
    this.confrimLoading = false;
    this.show = false;
    /* eslint-disable dot-notation */
    setTimeout(() => { this.$refs['dialog'].$destroy(); }, 3000);
  }

  private handleNotClose() {
    if (this.confrimLoading) {
      this.$emit('close', 'Loading');
      return true;
    }
    return false;
  }

  handleClose(type: string) {
    if (this.handleNotClose()) return;
    // this.callback && this.callback(type);
    this.close();
    this.$emit('close', 'Close');
  }

  handleConfrim() {
    if (this.confrimLoading) return;
    if (this.loading) this.confrimLoading = true;
    else this.close();
    this.$emit('close', 'OK');
  }

  handleCancel() {
    if (this.handleNotClose()) return;
    this.close();
    this.$emit('close', 'Cancel');
  }

  destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
}
